import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSimCard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sim-card-2"><path d="M19.25 2C19.6642 2 20 2.33579 20 2.75V21.25C20 21.6642 19.6642 22 19.25 22H4.75C4.33579 22 4 21.6642 4 21.25V7.16421C4 6.70009 4.18437 6.25497 4.51256 5.92678L7.92678 2.51256C8.25496 2.18437 8.70008 2 9.16421 2H11.5V7.25C11.5 7.66421 11.8358 8 12.25 8C12.6642 8 13 7.66421 13 7.25V2H15.5V7.25C15.5 7.66421 15.8358 8 16.25 8C16.6642 8 17 7.66421 17 7.25V2H19.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconSimCard2;
